<template>
  <div class="aboutContainer">
    <full-page :options="options" ref="fullpage">
      <div class="section pageBox1">
        <!-- 导航 -->
        <div class="navBar">
          <img
            class="navLogo"
            src="../assets/logo.png"
            alt=""
            @click="enterHome()"
          />
          <ul class="navBarItem">
            <!-- <li class="busiz-active-sel">
              <router-link exact to="/" tag="a">首页</router-link>
            </li> -->
            <li>
              <router-link to="/aboutlanshu" exact tag="a"
                >关于兰树</router-link
              >
            </li>
            <el-dropdown>
              <li>
                <router-link to="/huaiBrand" exact tag="a"
                  >兰树品牌</router-link
                >
              </li>
              <el-dropdown-menu class="elDropdown" slot="dropdown">
                <el-dropdown-item
                  ><router-link to="/huaiBrand" tag="a"
                    >淮树</router-link
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><router-link to="/brand" tag="a"
                    >心清堂</router-link
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><router-link to="/shuiBrand" tag="a"
                    >水姻缘</router-link
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><router-link to="/yiBrand" tag="a"
                    >一清堂</router-link
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><router-link to="/zhongBrand" tag="a"
                    >Dr.CHUNG<span style="vertical-align: super;">+</span></router-link
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><router-link to="/lanshuBrand" tag="a"
                    >兰树</router-link
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><router-link to="/zbqfBrand" tag="a"
                    >植本清方</router-link
                  ></el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <li>
              <router-link to="/park" exact tag="a">智慧园区</router-link>
            </li>
            <li>
              <router-link to="/brandLanshu" exact tag="a"
                >美业菩提</router-link
              >
            </li>
            <li>
              <router-link to="/school" exact tag="a">兰树商学院</router-link>
            </li>
            
            <li>
              <router-link to="/dynamicLanshu" exact tag="a"
                >菩提基金会</router-link
              >
            </li>
            
            <li>
              <router-link to="/lanshuTrends" exact tag="a"
                >兰树动态</router-link
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="section pageBox2">
        <div class="pageBoxOut">
          <div class="page2name">
            <div class="cn_title">兰树现代化智慧园区</div>
            <div class="en_title">LASUR MODERN INTELLIGENT PARK</div>
          </div>
          <div class="middleBox">
            <img
              class="bottomImg"
              src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_14-06-10_28087.png"
              alt=""
            />
            <div class="middleBoxLeft">
              兰树现代化智慧园区于2018年落户湖州莫干山国家级高新区，占地约85亩，总建筑面积达10.5万平方米，是集研发中心、工厂生产、现代物流、教育研修于一体的“花园式”现代化智慧型园区。以消费者为中心，以市场为导向，以科技创新为支撑，园区先后引进国际一流知名高端生产线及设备，现已建成具有国际先进水平的化妆品全产业链工厂。<br />
              <br />
            </div>
          </div>
          <!-- <div class="centerBottom">

					</div> -->
        </div>
      </div>
      <div class="section pageBox3">
        <div class="goTop" @click="scrollToTop"></div>
        <div class="page3box">
          <div class="p3top">国际一流技术和设备<br />全自动化智慧工厂</div>
          <div class="p3en">
            INTERNATIONAL FIRST-CLASS TECHNOLOGY<br />
            EQUIPMENT FULLY AUTOMATED SMART FACTORY
          </div>
          <div class="p3Line"></div>
          <div class="p3Detail">
            在生产端，企业全面开展技术化革新，推行数字化、柔性化、智能化生产，现已实现年产
            <span
              style="font-family: SourceHanSansCN-Bold;font-size: 1.35vw;font-weight: Bold;"
              >5000吨系列化妆品的产能</span
            >，进一步夯实企业高质量发展根基。通过引进国际一流
            的化妆品生产设备，全自动化控制及生产调度系统的应用，对产品质量进行精准控制，同时
            在减少污染、降低能耗上加大投入，极大的提高了生产能效，推动企业高质量可持续环保发展进程。
          </div>
        </div>
      </div>

      <div class="section pageBox4">
        <div class="goTop" @click="scrollToTop"></div>
        <div class="page4Left">
          <div class="leftbg"></div>
          <div class="leftPic"></div>
        </div>

        <div class="page4Right">
          <div class="topTitle">
            <div class="dian"></div>
            <div class="wen">
              <div class="p4top">
                国际知名品牌公司的<br />EKATO UNIMIX SRC__1000型号真空均质乳化机
              </div>
              <div class="p4en">
                EKATO UNIMIX SRC__1000 VACUUM HOMOGENIZING<br />
                EMULSIFIER FROM INTERNATIONALLY RENOWNED BRAND COMPANY
              </div>
            </div>
          </div>

          <!-- <div class="p3Line"></div> -->
          <div class="p4Detail">
            Ekato Unimix
            SRC__1000型号的真空均质乳化机国际顶级专家设计，整机采用304L不锈钢无间隙剪切速率高达
            54000 s-1，在线速度为 27 米/秒时。压力范围为-1
            到+2bar。高循环量，高剪切，高效脱气，精确控温，满足高品质产品的生产。
          </div>
        </div>
      </div>
      <div class="section pageBox5">
        <div class="goTop" @click="scrollToTop"></div>
        <div class="page4Left">
          <div class="leftbg5"></div>
          <div class="leftPic5"></div>
        </div>

        <div class="page5Right">
          <div class="topTitle">
            <div style="margin-right: 20px;">
              <div class="p4top">国家10万级GMP数字化洁净生产车间</div>
              <div class="p4en">
                NATIONAL 100,000 GMP DIGITAL CLEAN PRODUCTION WORKSHOP
              </div>
            </div>
            <div class="dian"></div>
          </div>

          <!-- <div class="p3Line"></div> -->
          <div class="p4Detail">
            工厂现拥有纯水、包材清洁、原材料储存、乳化、罐装、冻干等车间。其中6条水、乳、霜现代化自动罐装流水线，每条线全年可达到千万瓶；5条面膜现代化自动罐装流水线，全年可达上亿片。
          </div>
        </div>
      </div>
      <div class="section pageBox6">
        <div class="goTop" @click="scrollToTop"></div>
        <div class="page4Left">
          <div class="leftbg"></div>
          <div class="leftPic"></div>
        </div>

        <div class="page4Right">
          <div class="topTitle">
            <div class="dian"></div>
            <div class="wen">
              <div class="p4top">智慧物流仓储管理系统</div>
              <div class="p4en">
                INTELLIGENT LOGISTICS WAREHOUSING MANAGEMENT SYSTEM
              </div>
            </div>
          </div>

          <!-- <div class="p3Line"></div> -->
          <div class="p4Detail">
            兰树智慧物流仓储管理系统是基于物联网技术自主研发的一款仓储精细化管理软件，应用先进的物料识别技术对工厂各仓储库位进行精准识别和跟踪，实现对工厂物资的动态管理，进行仓储业务的精细化管理，解决工厂仓储过程中的问题，提高仓储作业效率、大幅提升工厂的仓储管理水平和服务水平。科学的管理系统实现了企业从现代化工厂向智能化仓储管理的转变。
          </div>
        </div>
      </div>

      <div class="section pageBox7">
        <div class="goTop" @click="scrollToTop"></div>
        <div class="page3box">
          <div class="p3top">兰树研发中心</div>
          <div class="p3en">LASUR RESEARCH AND DEVELOPMENT CENTER</div>
          <div class="p3Line"></div>
          <div class="p3Detail">
            兰树研发中心于2018年正式成立，建筑面积逾2600平方米。研发中心以首席技术官钟鸣先生为核心，汇集天然植物化学、生物学、医学、药学、精细化工等科研人员30余人，其中硕士研究生8人，汇聚国内顶尖专家技术团队，并与浙江大学达成长期战略合作，深入研发肌肤修护奥秘，目前已获得自主研发专利30余项。
          </div>
        </div>
      </div>

      <div class="section pageBox8">
        <div class="goTop" @click="scrollToTop"></div>
        <div class="pageBoxOut2">
          <!-- 底部 -->
          <div class="footerBox">
            <div class="footerBoxHeader">
              <div class="footerBoxHeaderLeft">
                <img class="codeImg" src="../assets/code.png" alt="" />
                <span class="codeText">兰树公众号</span>
              </div>
              <div class="footerBoxHeaderRight">
                <img class="codeImg" src="../assets/xcxNew.jpg" alt="" />
                <span class="codeText">兰树云小程序</span>
              </div>
              <!-- <div class="footerBoxHeaderRight">
					  				<img class="codeImg" src="../assets/code.png" alt="">
					  				<span class="codeText">兰树客服(QQ)</span>
					  			</div> -->
            </div>
            <div class="footerMainBox">
              <li class="footerShop">
                <a
                  target="_blank"
                  href="https://huaishu.tmall.com/shop/view_shop.htm?spm=a230r.7195193.1997079397.2.124378dduXIhiW"
                  >淮树旗舰店</a
                >
              </li>
              <li class="footerShop">
                <a
                  target="_blank"
                  href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s"
                  >心清堂官方企业店</a
                >
              </li>
              <li class="footerShop">
                <a target="_blank" href="https://shop349169226.taobao.com/?spm=a21xtw.29978516.0.0"
                  >水姻缘旗舰店</a
                >
              </li>
              <li class="footerShop">
                <a
                  target="_blank"
                  href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s"
                  >一清堂官方企业店</a
                >
              </li>
              <li class="footerShop">
                <a target="_blank" href="https://drchung.tmall.com"
                  ><span>Dr.CHUNG</span>旗舰店</a

                >
              </li>
              <li class="footerShop">
                <a target="_blank" href="https://zhibenqingfang.tmall.com"
                  >植本清方旗舰店</a
                >
              </li>
              <div class="lastHeader">
                <li><router-link to="/login" tag="a">登录</router-link></li>
                |
                <li><router-link to="/login" tag="a">注册</router-link></li>
              </div>
            </div>

            <div class="footerInfoBox">
              <div class="emailBox">邮箱: postermaster@lasur.com</div>
              <div class="phoneBox">电话: 0571-89025888</div>
              <div class="addressBox">
                地址: 浙江省杭州市之江东路越秀·维多利中心A座 17楼
              </div>
            </div>

            <div class="footerLine"></div>
            <div class="footerBoxBottom">
              <div class="footerLeft">
                Copyright © 2023 兰树化妆品股份有限公司
                <a
                  target="_blank"
                  href="https://beian.miit.gov.cn/#/Integrated/index"
                  >浙ICP备20018890号-1</a
                >
                | <img height="16px" src="../assets/plice.png" />&nbsp;<a
                  target="_blank"
                  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740"
                  >浙公网安备 33052102000740号</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </full-page>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: {
        licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
        //是否显示导航，默认为false
        navigation: true
      }
    };
  },
  methods: {
    scrollToTop() {
      fullpage_api.moveTo(1);
    },
    // over:function(){
    // 	var s = document.getElementById("zhi");
    // 	s.src="../assets/aboutLanshu/zhiC.png"
    // },

    // out:function(){
    // 	var s = document.getElementById("zhi");
    // 	s.src="../assets/aboutLanshu/zhi.png"
    // }
    enterHome() {
      this.$router.push({ path: "/" });
    }
  }
};
</script>

<style scoped>
.goTop {
  width: 2.6vw;
  height: 5.38vh;
  background: url(../assets/newLasur/goTop.png) no-repeat;
  background-position: 50% 50%;
  background-size: 100%;
  overflow: hidden;
  position: absolute;
  right: 3.8vw;
  bottom: 9.25vh;
  cursor: pointer;
  z-index: 999;
}
.goTop:hover {
  background: url(../assets/newLasur/goTop2.png) no-repeat;
  background-position: 50% 50%;
  background-size: 100%;
  overflow: hidden;
}

.aboutContainer {
  margin: 0;
  padding: 0;
}

.pageBox1 {
  width: 100%;
  background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-07-07_14-58-56_36937.jpg)
    no-repeat;
  background-position: 50% 50%;
  background-size: 100%;
  overflow: hidden;
}

.pageBox2 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.pageBoxOut {
  width: 100%;
  height: 100%;
  /* justify-content: center;
		display: flex;
		flex-direction: column;
		align-items:center; */
  margin: 0 auto;
  box-sizing: border-box;
}
.pageBoxOut2 {
  width: 100%;
  height: 100%;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  box-sizing: border-box;
}

.pageBoxOut3 {
  width: 100%;
  background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-06-26_14-13-23_50022.png)
    no-repeat;
  background-position: 50% 50%;
  background-size: 100%;
  overflow: hidden;
}

.page2name {
  width: 100%;
  height: 7vh;
  background: #0839de;
  margin-top: 6vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cn_title {
  width: 13.9vw;
  height: 4.5vh;
  line-height: 4.5vh;
  font-size: 1.46vw;
  font-family: SourceHanSansCN-Heavy;
  font-weight: Heavy;
  color: #ffffff;
  text-align: center;
  margin: 0 auto;
}

.en_title {
  width: 10.42vw;
  height: 2vh;
  line-height: 2vh;
  font-size: 0.52vw;
  font-family: SourceHanSansCN-Regular;
  font-weight: regulaar;
  color: #ffffff;
  margin: 0 auto;
  /* margin-top: 10px; */
}

.headerTitle1 {
  display: flex;
  font-size: 33px;
  font-family: SourceHanSansCN-Bold;
  font-weight: Bold;
  color: #0839de;
  line-height: 30px;
  justify-content: center;
}

.pageBoxTitle7 {
  margin-top: 5rem;
}

.headerTitle2 {
  display: flex;
  font-size: 15px;
  font-family: SourceHanSansCN-Normal;
  font-weight: normal;
  color: #111111;
  line-height: 20px;
  justify-content: center;
  margin-top: 10.5px;
}

.headerLine {
  display: flex;
  width: 113px;
  height: 4px;
  background: #80ff00;
  margin: 0 auto;
  border-radius: 1px;
  margin-top: 11.5px;
}

.middleBox {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  align-items: center;
  justify-content: space-around;
  box-sizing: border-box;
  margin-top: 12vh;
}

.middleBoxLeft {
  width: 65%;
  font-size: 0.9375vw;
  font-family: SourceHanSansCN-Normal;
  font-weight: normal;
  color: #000000;
  position: relative;
  left: -20em;
  opacity: 0;
  /* line-height: 26px; */
  /* line-height: 23px; */
  /* letter-spacing: 0.05rem; */
  box-sizing: border-box;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
  /* text-indent: 2em; */
  margin-top: 6.67vh;
  /* animation: middleText 3s;
		-webkit-animation: middleText 3s; */
}

.middleBoxLeftNew {
  margin-top: 0.5rem !important;
}

.pageBox2.active .middleBoxLeft {
  opacity: 1;
  left: 0;
}

/* 动画效果 */
@keyframes middleText {
  from {
    opacity: 0;
    left: -20em;
  }
  to {
    opacity: 1;
    left: 0;
  }
}

@-webkit-keyframes rightImg /* Safari 和 Chrome */ {
  from {
    opacity: 0;
    left: -20em;
  }
  to {
    opacity: 1;
    left: 0;
  }
}

.middleBoxRight {
  width: 29%;
  z-index: 999;
  animation: rightImg 3s;
  -webkit-animation: rightImg 3s; /* Safari 和 Chrome */
}

/* 动画效果 */
@keyframes rightImg {
  from {
    opacity: 0;
    width: 0%;
  }
  to {
    opacity: 1;
    width: 65%;
  }
}

@-webkit-keyframes rightImg /* Safari 和 Chrome */ {
  from {
    opacity: 0;
    width: 0%;
  }
  to {
    opacity: 1;
    width: 65%;
  }
}

.bottomImg {
  width: 0%;
  opacity: 0;
  box-sizing: border-box;
  position: relative;
  -moz-transition: 2s;
  -webkit-transition: 2s;
  /* animation: rightImg 3s;
		-webkit-animation: rightImg 3s;	 */
}

.headerTitleCul {
  line-height: 30px !important;
}

.pageBox2.active .bottomImg {
  width: 65%;
  opacity: 1;
}

.centerBottom {
  width: 76%;
  /* display: flex; */
  margin: 0 auto;
  box-sizing: border-box;
}

.pageBox3 {
  overflow: hidden;
  background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_14-04-52_66853.png)
    no-repeat;
  background-position: 50% 50%;
  background-size: 100%;
}

.page3box {
  width: 40.15vw;
  margin-left: 10vw;
}
.pageBox3.active .page3box {
  animation: bounceInLeft 2s;
  -webkit-animation: bounceInLeft 2s;
}

.pageBox7.active .page3box {
  animation: bounceInLeft 2s;
  -webkit-animation: bounceInLeft 2s;
}

.pageBox4.active .page4Right {
  animation: bounceInRight 2s;
  -webkit-animation: bounceInRight 2s;
}
.pageBox6.active .page4Right {
  animation: bounceInRight 2s;
  -webkit-animation: bounceInRight 2s;
}

.pageBox5.active .page5Right {
  animation: bounceInLeft 2s;
  -webkit-animation: bounceInLeft 2s;
}

@keyframes bounceInLeft {
  0% {
    opacity: 0;
    transform: translate3d(-300px, 0, 0);
  }

  /* 60% {
			opacity: 1;
			transform: translate3d(25px, 0, 0);
		}
 
		75% {
			transform: translate3d(-10px, 0, 0);
		}
 
		90% {
			transform: translate3d(5px, 0, 0);
		} */

  100% {
    transform: none;
  }
}

@keyframes bounceInRight {
  0% {
    opacity: 0;
    transform: translate3d(300px, 0, 0);
  }

  /* 60% {
			opacity: 1;
			transform: translate3d(-25px, 0, 0);
		}
 
		75% {
			transform: translate3d(10px, 0, 0);
		}
 
		90% {
			transform: translate3d(-5px, 0, 0);
		} */

  100% {
    transform: none;
  }
}

.p3top {
  width: 28vw;
  font-size: 2.08vw;
  font-family: SourceHanSansCN-Bold;
  font-weight: bold;
  color: #ffffff;
}
.p3en {
  font-size: 0.73vw;
  font-family: SourceHanSansCN-Medium;
  font-weight: medium;
  color: #ffffff;
  margin-top: 3.76vh;
}
.p3Line {
  width: 8.54vw;
  height: 0.43vh;
  background: #80ff00;
  border-radius: 1px;
  margin-top: 4.35vh;
}

.p3Detail {
  height: 18.5vh;
  line-height: 3.7vh;
  font-size: 0.99vw;
  font-family: SourceHanSansCN-Regular;
  font-weight: regular;
  color: #ffffff;
  margin-top: 4.84vh;
}

.mainBox {
  width: 75%;
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  justify-content: space-around;
  margin-top: 2rem;
}

.mainBoxItem {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mainBoxTitleBox {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  position: relative;
  top: 50%;
  opacity: 0;
  -moz-transition: 1s;
  -webkit-transition: 1s;
  /* animation: mainTitle 3s;
		-webkit-animation: mainTitle 3s; */
}

.pageBox3.active .mainBoxTitleBox {
  top: 0;
  opacity: 1;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  position: relative;
}

/* 动画效果 */
@keyframes mainTitle {
  from {
    opacity: 0;
    top: 30%;
  }
  to {
    opacity: 1;
    top: 0;
  }
}

@-webkit-keyframes mainTitle {
  from {
    opacity: 0;
    top: 30%;
  }
  to {
    opacity: 1;
    top: 0;
  }
}

.mainBoxItemImg {
  width: 0%;
  opacity: 0;
  position: relative;
  transform: rotate(0deg);
  -moz-transition: 2s;
  -webkit-transition: 2s;
  /* animation: xuanzhuan 3s;
		-webkit-animation: xuanzhuan 3s; */
}

.valueBottom {
  margin-top: 80px;
  width: 96px;
  height: 25px;
}

.valueBottom img {
  width: 100%;
  height: 100%;
}

.pageBox3.active .mainBoxItemImg {
  width: 70%;
  opacity: 1;
  position: relative;
}

/* 动画效果 */
@keyframes xuanzhuan {
  from {
    opacity: 0;
    transform: rotate(270deg);
  }
  to {
    opacity: 1;
    transform: rotate(0deg);
  }
}

@-webkit-keyframes xuanzhuan {
  from {
    opacity: 0;
    transform: rotate(270deg);
  }
  to {
    opacity: 1;
    transform: rotate(0deg);
  }
}

.pageBox4 {
  background-color: #ffffff;
  overflow: hidden;
  position: relative;
}

.page4Left img {
  width: 100%;
  height: 100%;
}

.pageBox4.active .leftPic {
  width: 38.23vw;
  height: 57.7vh;
  border-radius: 2.58vh;
  background: url("https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_14-03-04_92204.png")
    no-repeat center 0px;
  background-position: center 0px;
  background-size: cover;
  overflow: hidden;
  cursor: pointer;
}
.pageBox4.active .leftPic:hover {
  width: 38.23vw;
  height: 57.7vh;
  border-radius: 2.58vh;
  background: url("https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_13-58-49_42351.gif")
    no-repeat center 0px;
  background-position: center 0px;
  background-size: cover;
  overflow: hidden;
}
.pageBox5.active .leftPic5 {
  width: 38.23vw;
  height: 57vh;
  border-radius: 2.58vh;
  background: url("https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_14-03-49_49355.png")
    no-repeat center 0px;
  background-position: center 0px;
  background-size: cover;
  overflow: hidden;
  cursor: pointer;
}
.pageBox5.active .leftPic5:hover {
  width: 38.23vw;
  height: 57vh;
  border-radius: 2.58vh;
  background: url("https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_13-57-02_51630.gif")
    no-repeat center 0px;
  background-position: center 0px;
  background-size: cover;
  overflow: hidden;
}
.pageBox6.active .leftPic {
  width: 38.23vw;
  height: 57.7vh;
  border-radius: 2.58vh;
  background: url("https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_14-04-16_48639.png")
    no-repeat center 0px;
  background-position: center 0px;
  background-size: cover;
  overflow: hidden;
  cursor: pointer;
}
.pageBox6.active .leftPic:hover {
  width: 38.23vw;
  height: 57.7vh;
  border-radius: 2.58vh;
  background: url("https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_13-59-18_85809.gif")
    no-repeat center 0px;
  background-position: center 0px;
  background-size: cover;
  overflow: hidden;
}

.leftbg {
  width: 38.23vw;
  height: 59.57vh;
  background: #0839de;
  border-radius: 2.58vh;
  position: absolute;
  top: 19vh;
  left: 9.6875vw;
}
.leftbg5 {
  width: 38.23vw;
  height: 59.57vh;
  background: #0839de;
  border-radius: 2.58vh;
  position: absolute;
  top: 19vh;
  right: 8.28vw;
}
.leftPic5 {
  width: 0vw;
  height: 0vh;
  position: absolute;
  top: 21.82vh;
  right: 9.11vw;
  -moz-transition: 2s;
  -webkit-transition: 2s;
}

.leftPic {
  width: 0vw;
  height: 0vh;
  position: absolute;
  top: 21.82vh;
  left: 8.85vw;
  -moz-transition: 2s;
  -webkit-transition: 2s;
}

.page4Right {
  width: 41vw;
  position: absolute;
  top: 31.5vh;
  right: 8.96vw;
}
.page5Right {
  width: 41vw;
  position: absolute;
  top: 31.5vh;
  left: 8.96vw;
  text-align: right;
}

.leftPic img {
  width: 100%;
  height: 100%;
}
.leftPic5 img {
  width: 100%;
  height: 100%;
}

.topTitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.dian {
  margin-top: 20px;
  width: 1.2vw;
  height: 2.47vh;
  background: #80ff00;
  border-radius: 5px;
}
.wen {
  margin-left: 20px;
}
.p4top {
  width: 38.33vw;
  font-size: 1.5625vw;
  font-family: SourceHanSansCN-Bold;
  font-weight: bold;
  color: #0839de;
}
.p4en {
  font-size: 0.78125vw;
  font-family: SourceHanSansCN-Medium;
  font-weight: medium;
  color: #0839de;
  margin-top: 3.22vh;
}

.p4Detail {
  width: 41vw;
  height: 13.33vh;
  font-size: 0.9375vw;
  font-family: SourceHanSansCN-Medium;
  font-weight: medium;
  color: #000000;
  line-height: 4.44vh;
  margin-top: 6.24vh;
}

.cultureBox {
  position: relative;
  width: 67.9vw;
  height: 34.3vh;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin: 0 auto;
  margin-top: 7.85vh;
  box-sizing: border-box;
  background: blue;
}

.bg {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}

.pageBox4.active .cultureItem {
  animation: bounceInLeft 2s cubic-bezier(0.215, 0.61, 0.355, 1) 0s 1 alternate
    forwards;
  -webkit-animation: bounceInLeft 2s cubic-bezier(0.215, 0.61, 0.355, 1) 0s 1
    alternate forwards;
  /*Safari and Chrome*/
}

/* @keyframes bounceInLeft {
		0% {
			opacity: 0;
			transform: translate3d(-3000px, 0, 0);
		}
 
		60% {
			opacity: 1;
			transform: translate3d(25px, 0, 0);
		}
 
		75% {
			transform: translate3d(-10px, 0, 0);
		}
 
		90% {
			transform: translate3d(5px, 0, 0);
		}
 
		100% {
			transform: none;
		}
	} */

.cultureItem {
  text-align: center;
}

.cultureItemImg {
  width: 11.9vw;
  height: 24.57vh;
}

.cultureTitle {
  min-width: 119px;
  height: 15px;
  font-size: 15px;
  font-family: SourceHanSansCN-Medium;
  font-weight: medium;
  color: #ffffff;
  margin-top: 20px;
}

.pageBox5 {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f6f7f8;
  overflow: hidden;
}

.ideaBox {
  width: 90%;
  margin: 0 auto;
  display: flex;
  margin-top: 1rem;
  box-sizing: border-box;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}

.ideaBoxLeft {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ideaTitleBox {
  width: 90%;
  display: flex;
  flex-direction: column;
  margin-left: 2em;
}

.ideaTitle1 {
  font-size: 1.2em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 22px;
}

.ideaTitle2 {
  font-size: 1em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  margin-top: 1em;
}

.ideaTitle3 {
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
}

.ideaBoxLeftItem {
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 2rem;
  position: relative;
  left: -15rem;
  opacity: 0;
  transition: 3s ease;
  -moz-transition: 2s;
  -webkit-transition: 2s;
  /* animation: leftItem 10s;
		-webkit-animation: leftItem 10s; */
}

.pageBox5.active .ideaBoxLeftItem {
  opacity: 1;
  left: 0rem;
  position: relative;
}

/* 动画效果 */
@keyframes leftItem {
  from {
    opacity: 0;
    left: -15em;
  }
  to {
    opacity: 1;
    left: 0;
  }
}

@-webkit-keyframes leftItem {
  from {
    opacity: 0;
    left: -15em;
  }
  to {
    opacity: 1;
    left: 0;
  }
}

.ideaBoxRightItem {
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 2em;
  position: relative;
  left: 15rem;
  opacity: 0;
  -moz-transition: 2s;
  -webkit-transition: 2s;
  /* animation: rightItem 10s;
		-webkit-animation: rightItem 10s; */
}

.pageBox5.active .ideaBoxRightItem {
  opacity: 1;
  left: 0rem;
  position: relative;
}

/* 动画效果 */
@keyframes rightItem {
  from {
    opacity: 0;
    left: 15em;
  }
  to {
    opacity: 1;
    left: 0;
  }
}

@-webkit-keyframes rightItem /* Safari 和 Chrome */ {
  from {
    opacity: 0;
    left: 15em;
  }
  to {
    opacity: 1;
    left: 0;
  }
}

/*
	.ideaItem2 .ideaImgBox{
		margin-left:12%;
	} */

/* .ideaItem5 .ideaImgBox{
		margin-left:2rem;
	} */

/* .ideaItem4 .ideaImgBox{
		margin-left:1%;
	}
	 */

.treeImg {
  width: 80%;
}

/* tree动画效果 */
@keyframes tree {
  from {
    opacity: 0;
    width: 100%;
  }
  to {
    opacity: 1;
    width: 100%;
  }
}

@-webkit-keyframes tree {
  from {
    opacity: 0;
    width: 100%;
  }
  to {
    opacity: 1;
    width: 100%;
  }
}

.ideaImg {
  width: 35px;
}

.ideaBoxMiddle {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
  /* margin-left: -3em; */
  /* animation: tree 10s;
		-webkit-animation: tree 10s; */
}

.ideaBoxRight {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pageBox6 {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.teamBox {
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 0 auto;
  margin-top: 3%;
  box-sizing: border-box;
}

.teamBoxItem {
  width: 18%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: 1s;
  cursor: pointer;
  overflow: hidden;
  opacity: 0;
  -moz-transition: 1s;
  -webkit-transition: 1.5s;
  /* transform:rotate(0deg); */
  /* box-shadow: 0 5px 15px -5px rgba(0,0,0,.5); */
  /* animation: team 5s;
		-webkit-animation: team 5s; */
}

.pageBox6.active .teamBoxItem {
  opacity: 1;
  width: 24%;
}

/* 精英团队动画效果 */
@keyframes team {
  from {
    opacity: 0;
    transform: rotate(120deg);
  }
  to {
    opacity: 1;
    transform: rotate(0deg);
  }
}

@-webkit-keyframes team {
  from {
    opacity: 0;
    transform: rotate(120deg);
  }
  to {
    opacity: 1;
    transform: rotate(0deg);
  }
}

.teamBoxItem:hover .teamItemImg {
  transform: scale(1.05);
  transition: 1.5s ease;
}

.teamBoxItem:hover .teamTitleBox {
  background: #003f98;
  transition: 1.5s ease;
}

.teamBoxItem:hover .teamTitle1 {
  color: #ffffff;
  transition: 1s ease;
}

.teamBoxItem:hover .teamTitle2 {
  color: #ffffff;
  transition: 1s ease;
}

.teamTitleBox {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ebebeb;
  transition: 1s ease;
  overflow: hidden;
  margin-top: -4rem;
  z-index: 999;
}

.teamItemImg {
  width: 100%;
  transition: 1s ease;
}

.teamTitle1 {
  font-size: 1.625em;
  font-family: MicrosoftYaHei;
  color: #222;
  line-height: 10px;
  margin-top: 1em;
  transition: 1s ease;
}

.teamTitle2 {
  font-size: 1em;
  font-family: MicrosoftYaHei;
  color: #222;
  line-height: 19px;
  margin-top: 1em;
  padding-bottom: 1em;
  transition: 1s ease;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* pageBox7 */
.pageBox7 {
  overflow: hidden;
  background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_14-04-52_66853.png)
    no-repeat;
  background-position: 50% 50%;
  background-size: 100%;
}

.carouselBox {
  width: 90%;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
}

.carouselItem {
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-content: center;
  flex-direction: row;
}

.itemBox {
  width: 70%;
  margin: 0 auto;
  display: flex;
  align-content: center;
  flex-direction: row;
  flex-wrap: wrap;
}

.itemImgBox {
  width: 30%;
  margin-left: 3%;
}

.itemImgBoximg {
  width: 100%;
}

/* footer */
.pageBox8 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  background-color: #f8f9fb;
}

.footerBox {
  width: 90%;
  /* height: 287px; */
  background: #f8f9fb;
  /* position:absolute;
	 	bottom:0; */
  margin: 0 auto;
  flex-direction: column;
  z-index: 999;
}

.footerBoxHeader {
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 2%;
}

.footerBoxHeaderLeft {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.footerBoxHeaderLeft,
.footerBoxHeaderRight {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-align: center;
  align-items: center;
}
.footerBoxHeaderRight {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 5em;
}

.footerBoxHeaderMiddle {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.codeImg {
  width: 100%;
}

.codeText {
  font-size: 0.88em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  /* margin-top: 0em; */
}

.footerLine {
  width: 79%;
  height: 1px;
  display: flex;
  background: #000000;
  opacity: 0.1;
  margin: 0 auto;
  align-items: center;
  margin-top: 1em;
}

.footerInfoBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
}

.emailBox {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 20px;
}

.phoneBox {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 20px;
  margin-top: 0.5rem;
}

.addressBox {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 20px;
  margin-top: 0.5rem;
}

.footerBoxBottom {
  display: flex;
  margin: 0 auto;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  margin-top: 1rem;
}

.footerLeft {
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}

.footerLeft a {
  text-decoration: none;
  cursor: pointer;
  color: #666666;
}

.footerLeft a:hover {
  color: #003f98;
}

.footerMiddle {
  display: flex;
  flex-direction: column;
  margin-left: 1em;
}

.footerMiddle span {
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}

.footerRight {
  display: flex;
  flex-direction: column;
  margin-left: 1em;
}

.footerRight li a {
  text-decoration: none;
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 28px;
}

.footerRight li {
  list-style: none;
}

.footerLast {
  display: flex;
  flex-direction: column;
  margin-left: 1em;
}

.lastHeader {
  display: flex;
  flex-direction: row;
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 28px;
  margin-left: 2em;
}

.lastHeader li a {
  text-decoration: none;
  font-size: 0.875rm;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 28px;
}

.lastHeader li {
  list-style: none;
}

.footerLast span {
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}

.footerMainBox {
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  margin-top: 2em;
}

.footerShop {
  list-style: none;
  position: relative;
}

.footerShop span {
  margin-right: 10px;
}
.footerShop span::after {
  content: "+";
  display: block;
  position: absolute;
  top: -6px;
  right: 43px;
}
.footerShop a {
  text-decoration: none;
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  padding-left: 2em;
  line-height: 28px;
}

/* 导航 */
.navBar {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  justify-content: space-between;
  top: 0;
  /* border-bottom:1px solid rgba(255,255,255,0.2); */
  z-index: 9999;
}

.router-link-active {
  border-bottom: 3px solid #ffffff;
}

.navLogo {
  width: 10%;
  margin-left: 5em;
  cursor: pointer;
}

.navBarItem {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  /* margin-right: 5em; */
}

.navBarItem li {
  list-style: none;
  /*padding: 1.56em 2.5em 1.56em 2.5em;*/
  float: left;
  /* margin-left: 2em; */
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.navBarItem li a {
  text-decoration: none;
  font-size: 0.875rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 20px;
  padding-top: 1.3em;
  padding-bottom: 1.3em;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
}

/* .elDropdown{
		margin-left: -5em;
		margin-top: -1em;
	} */

.elDropdown a {
  color: #111111;
  text-decoration: none;
}

.el-dropdown {
  vertical-align: top;
}
.el-dropdown + .el-dropdown {
  margin-left: 15px;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.el-dropdown-link {
  cursor: pointer;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/ParkLanShu.vue